import React, {useCallback, useContext, useEffect, useRef, useState} from "react";
import Image from "components/image";
import Link from "helpers/link";
import { TELEPHONE_NUMBER } from "utils/constants";
import cartIcon from "assets/svgs/cart-icon.svg";
import telephoneIcon from "assets/svgs/telephone-icon.svg";
import { CartContext } from "context/cart";
import DesktopHeaderData from "./data";
import "./style.scss";
import SearchByImage from "@root/components/header/search-by-image";
import GlobalSearch from "@root/components/header/global-search";

const DesktopHeader = ({ data: { logo, links } }) => {
    const { cart: { items } } = useContext(CartContext);

    return (
        <>
            <div className="header__dropdown-overlay" />
            <header className="header header--desktop">
                <div aria-label="Main Menu" className="header__nav container">
                    <div className="header__image">
                        <Image image={logo} to="/" width={200} className="header__logo" />
                    </div>
                    <div style={{flex: 1}} />
                    <GlobalSearch />
                    {/*<SearchByImage />*/}
                    <div className="header__actions">
                        <Link to={TELEPHONE_NUMBER} aria-label="Call Us" className="header__actions--phone">
                            <img alt="Call Us" className="w-8 xl:w-10" width={32} height={32} src={telephoneIcon} />
                            <p>{TELEPHONE_NUMBER}</p>
                        </Link>
                        <Link to="/cart" aria-label="Navigate to cart page" className="header__actions--cart">                        
                            <div className="relative">
                                <img alt="Navigate to cart page" className="header_action-shopping-bag" width={32} height={32} src={cartIcon} />
                                {items?.length ? <div className="header__cart-badge" /> : <div className="header__cart-badge--hidden" />}
                            </div>
                            <p> Cart </p>
                        </Link>
                    </div>
                </div>
                <nav className="header__nav">
                    <div className="container">
                        <DesktopHeaderData data={links} />
                    </div>
                </nav>
            </header>
        </>
    );
};

export default DesktopHeader;
